import { DynamicDialogRef } from 'primeng/dynamicdialog';

export const services = [DynamicDialogRef];

export * from 'primeng/dynamicdialog';
